import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Row,
  Card,
  Accordion,
  useAccordionButton,
  Badge,
  Form,
  InputGroup,
} from "react-bootstrap";
import {
  faBell,
  faCheck,
  faInfoCircle,
  faList,
  faMinus,
  faMoneyBill,
  faPlus,
  faStar,
  faTicket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  addNotifyOrden,
  utilGetCollectionFilter,
  utilGetCollectionFilterReference,
} from "../../../util/UtilsFirebase";
import { v4 as uuidv4 } from "uuid";
import "./Orden.css";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  onSnapshot,
  query,
  setDoc,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import Ticket from "./Ticket";
import ReactSwitch from "react-switch";
import { projectFirestore } from "../../../firebase/config";

const OrdenLista = ({
  fecha,
  hora,
  register,
  orden,
  openPedido,
  mixto,
  vencimiento,
  tiempo,
  employee,
  cajaID,
  handleimprimir,
}) => {
  const [usera, setUsera] = useState([]);
  const [active, setActive] = useState(false);
  const [vencimientoR, setVencimiento] = useState();
  const [userPoints, setUserPoints] = useState({});
  const [ticket, setTicket] = useState(false);
  const [metodosPago, setMetodosPago] = useState(
    orden.metodosPago
      ? orden.metodosPago
      : { efectivo: "0", tarjeta: "0", vale: "0", transferencia: "0" },
  );
  const [puntos, setPuntos] = useState(parseFloat(orden.puntosusados));
  const [imprimir, setImprimir] = useState(true);
  const quickAmounts = [50, 100, 200, 500, 1000];

  const Llamada = () => {
    let notificacion = {};
    let msg = "¿Requiere la presencia del cliente?";
    notificacion = {
      idv4: uuidv4(),
      turno_id: orden.id,
      user: orden.user,
      user_name: orden.user_name,
      status: "AVISO",
      number: orden.number,
      puesto_name: orden.puesto_name,
      tipo_pago: orden.tipo_pago,
      description: "Se requiere de su presencia en " + orden.puesto_name,
      active: true,
      pending: true,
      fecha: Timestamp.now(),
    };
    if (window.confirm(msg)) {
      addNotifyOrden(notificacion);
    }
  };

  function CustomToggle({ text, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      setActive(!active);
    });

    return (
      <Button
        variant="ds"
        className="newbutton-style filled fullspace"
        id="efectivo"
        onClick={decoratedOnClick}
      >
        <FontAwesomeIcon icon={faMoneyBill} /> Cobrar
      </Button>
    );
  }

  const handleClose = () => {
    setTicket(false);
  };

  const totmp = Object.keys(metodosPago).reduce((acc, item) => {
    return acc + parseFloat(metodosPago[item]);
  }, 0);

  const tot = parseFloat(orden.total) - puntos - totmp;

  const confirmCobro = async (impres) => {
    if (tot > 0) {
      alert("Aun faltan $" + tot.toFixed(2));
      return;
    }
    // const confirmVal = window.confirm(
    //   "¿Estás seguro de que deseas generar el turno?",
    // );
    // if (confirmVal && !orden) {
    const updatedOrderGenerar = {
      ...orden,
      status: "ATENDIDO",
      tipo_pago: "Mixto",
      metodosPago: metodosPago,
      tipo_venta: "Mostrador",
      caja: cajaID,
      ordenadoPor: "Web Rapdis",
      puntosusados: puntos,
    };
    if (employee !== undefined) {
      updatedOrderGenerar.atendio = employee.id_usuario;
    } else {
      updatedOrderGenerar.atendio = "Administrador";
    }
    updatedOrderGenerar.cobro = totmp;
    updatedOrderGenerar.cambio = tot;
    if (userPoints.id) {
      updatedOrderGenerar.reclamados = true;
    } else {
      updatedOrderGenerar.reclamados = false;
    }
    if (
      metodosPago.efectivo > 0 &&
      metodosPago.tarjeta <= 0 &&
      metodosPago.vale <= 0 &&
      metodosPago.transferencia <= 0
    ) {
      updatedOrderGenerar.tipo_pago = "Efectivo";
    } else if (
      metodosPago.efectivo <= 0 &&
      metodosPago.tarjeta > 0 &&
      metodosPago.vale <= 0 &&
      metodosPago.transferencia <= 0
    ) {
      updatedOrderGenerar.tipo_pago = "Tarjeta";
    } else if (
      metodosPago.efectivo <= 0 &&
      metodosPago.tarjeta <= 0 &&
      metodosPago.vale > 0 &&
      metodosPago.transferencia <= 0
    ) {
      updatedOrderGenerar.tipo_pago = "Vales";
    } else if (
      metodosPago.efectivo <= 0 &&
      metodosPago.tarjeta <= 0 &&
      metodosPago.vale <= 0 &&
      metodosPago.transferencia > 0
    ) {
      updatedOrderGenerar.tipo_pago = "Transferencia";
    } else {
      updatedOrderGenerar.tipo_pago = "Mixto";
    }
    await updateDoc(
      doc(projectFirestore, "turnero", orden.id),
      updatedOrderGenerar,
    );
    if (userPoints.id) {
      if (puntos > 0) {
        addDoc(
          collection(projectFirestore, "puntos", userPoints.id, "historial"),
          {
            descripcion: "Se usaron " + puntos + " puntos",
            fecha: new Date(),
            folioOrden: orden.folio,
          },
        );
      }
      if (parseFloat(orden.puntosgenerados) > 0) {
        addDoc(
          collection(projectFirestore, "puntos", userPoints.id, "historial"),
          {
            descripcion: "Obtuviste " + orden.puntosgenerados + " puntos",
            fecha: new Date(),
            folioOrden: orden.folio,
          },
        );
      }
      setDoc(doc(projectFirestore, "puntos", userPoints.id), {
        id_usuario: orden.user,
        id_local: register.id,
        puntos:
          parseFloat(userPoints.puntos) -
          parseFloat(puntos) +
          parseFloat(orden.puntosgenerados),
      });
    }
    if (orden.user) {
      let notificacion = {
        idv4: uuidv4(),
        turno_id: orden.id,
        user: orden.user,
        user_name: orden.user_name,
        status: "ATENDIDO",
        number: orden.number,
        puesto_name: orden.puesto_name,
        tipo_pago: orden.tipo_pago,
        description: "Su orden con numero: " + orden.number + ", esta pagada.",
        active: true,
        pending: true,
        fecha: Timestamp.now(),
      };
      await addNotifyOrden(notificacion);
    }
    const menu = await utilGetCollectionFilterReference(
      "menu",
      "registro",
      "==",
      register.id,
      "registro",
    );
    let menuid = menu[0].id;
    updatedOrderGenerar.detalle.forEach(async (itemdet) => {
      if (itemdet?.id && itemdet?.selectedDate) {
        const documplat = doc(
          projectFirestore,
          "menu",
          menuid,
          "platillo",
          itemdet.id,
        );
        if (itemdet?.selectedDate && itemdet?.selectedTime) {
          const dataplat = (await getDoc(documplat)).data();
          let dispo3 = { ...dataplat?.reservados };
          if (
            dispo3 &&
            dispo3[itemdet?.selectedDate] &&
            dispo3[itemdet?.selectedDate][itemdet?.selectedTime]
          ) {
            dispo3[itemdet?.selectedDate][itemdet?.selectedTime] =
              dispo3[itemdet?.selectedDate][itemdet?.selectedTime] -
              itemdet?.cantidad;
          }
          let dispo2 = { ...dataplat?.fechas };
          if (
            dispo2 &&
            dispo2[itemdet?.selectedDate] &&
            dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
          ) {
            dispo2[itemdet?.selectedDate][itemdet?.selectedTime] =
              dispo2[itemdet?.selectedDate][itemdet?.selectedTime] +
              itemdet?.cantidad;
          } else if (
            dispo2 &&
            dispo2[itemdet?.selectedDate] &&
            !dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
          ) {
            dispo2 = {
              ...dispo2,
              [itemdet?.selectedDate]: {
                ...dispo2[itemdet?.selectedDate],
                [itemdet?.selectedTime]: itemdet?.cantidad,
              },
            };
          } else if (dispo2 && !dispo2[itemdet?.selectedDate]) {
            dispo2 = {
              ...dispo2,
              [itemdet?.selectedDate]: {
                [itemdet?.selectedTime]: itemdet?.cantidad,
              },
            };
          } else {
            dispo2 = {
              [itemdet?.selectedDate]: {
                [itemdet?.selectedTime]: itemdet?.cantidad,
              },
            };
          }
          updateDoc(documplat, {
            fechas: dispo2,
            reservados: dispo3,
          });
        } else {
          const dataplat = (await getDoc(documplat)).data();
          let dispo3 = { ...dataplat?.reservados };
          if (
            dispo3 &&
            dispo3[itemdet?.selectedDate] &&
            dispo3[itemdet?.selectedDate][itemdet?.selectedDate]
          ) {
            dispo3[itemdet?.selectedDate][itemdet?.selectedDate] =
              dispo3[itemdet?.selectedDate][itemdet?.selectedDate] -
              itemdet?.cantidad;
          }
          let dispo2 = { ...dataplat?.fechas };
          if (
            dispo2 &&
            dispo2[itemdet?.selectedDate] &&
            dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
          ) {
            dispo2[itemdet?.selectedDate][itemdet?.selectedDate] =
              dispo2[itemdet?.selectedDate][itemdet?.selectedDate] +
              itemdet?.cantidad;
          } else if (
            dispo2 &&
            dispo2[itemdet?.selectedDate] &&
            !dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
          ) {
            dispo2 = {
              ...dispo2,
              [itemdet?.selectedDate]: {
                ...dispo2[itemdet?.selectedDate],
                [itemdet?.selectedDate]: itemdet?.cantidad,
              },
            };
          } else if (dispo2 && !dispo2[itemdet?.selectedDate]) {
            dispo2 = {
              ...dispo2,
              [itemdet?.selectedDate]: {
                [itemdet?.selectedDate]: itemdet?.cantidad,
              },
            };
          } else {
            dispo2 = {
              [itemdet?.selectedDate]: {
                [itemdet?.selectedDate]: itemdet?.cantidad,
              },
            };
          }
          updateDoc(documplat, {
            fechas: dispo2,
            reservados: dispo3,
          });
        }
      }
    });
    if (imprimir === true) {
      handleimprimir(updatedOrderGenerar);
    }
    return [updatedOrderGenerar];
    // }
  };

  const changePago = (e) => {
    if (!isNaN(parseFloat(e.key))) {
      if (
        (parseFloat(metodosPago[e.target.name]) === 0 &&
          metodosPago[e.target.name] !== "0.") ||
        isNaN(parseFloat(metodosPago[e.target.name]))
      ) {
        setMetodosPago({
          ...metodosPago,
          [e.target.name]: e.key,
        });
      } else {
        setMetodosPago({
          ...metodosPago,
          [e.target.name]: metodosPago[e.target.name] + e.key,
        });
      }
    }
    if (e.key === "Backspace") {
      if (
        metodosPago[e.target.name].length === 1 ||
        metodosPago[e.target.name].length === 0
      ) {
        setMetodosPago({
          ...metodosPago,
          [e.target.name]: "0",
        });
      } else {
        setMetodosPago({
          ...metodosPago,
          [e.target.name]: metodosPago[e.target.name].slice(0, -1),
        });
      }
    }
    if (e.key === "." && !metodosPago[e.target.name].includes(".")) {
      setMetodosPago({
        ...metodosPago,
        [e.target.name]: metodosPago[e.target.name] + e.key,
      });
    }
    if (e.key === "Enter") {
      switch (e.target.name) {
        case "efectivo":
          document.getElementById("tarjeta" + orden.id).focus();
          break;
        case "tarjeta":
          document.getElementById("vale" + orden.id).focus();
          break;
        case "vale":
          document.getElementById("transferencia" + orden.id).focus();
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    if (orden?.atendio && orden.atendio !== "Administrador") {
      const personal = utilGetCollectionFilter(
        "users",
        "id",
        "==",
        orden.atendio,
      );
      personal.then((result) => {
        setUsera(result[0]);
      });
    } else {
      let userd = {
        fullName: orden.atendio,
      };
      setUsera(userd);
    }
  }, [orden.atendio]);

  useEffect(() => {
    if (vencimiento && orden.fecha_exp) {
      const inter = setInterval(() => {
        const actual = new Date();
        const fechaO = new Date(orden.fecha_exp.seconds * 1000);
        const diferenciaMs = fechaO - actual;
        const dif = diferenciaMs / (1000 * 60);
        if (dif <= 0) {
          clearInterval(inter);
        }
        if (!isNaN(dif)) setVencimiento(dif);
      }, 1000);
      return () => clearInterval(inter);
    }
  }, [orden, tiempo, vencimiento]);

  useEffect(() => {
    if (active && orden.user) {
      let p = query(collection(projectFirestore, "puntos"));
      p = query(
        p,
        where("id_usuario", "==", orden.user),
        where("id_local", "==", register.id),
      );
      onSnapshot(p, async (docd) => {
        docd.docs.forEach((element) => {
          if (element.exists()) {
            let datos = element.data();
            datos.id = element.id;
            setUserPoints(datos);
          }
        });
        if (docd.empty) {
          await addDoc(collection(projectFirestore, "puntos"), {
            id_usuario: orden.user,
            id_local: register.id,
            puntos: 0,
          });
        }
      });
    }
  }, [active, orden.user, register.id]);

  return (
    <Col
      key={orden.id}
      xs={12}
      md={12}
      lg={active ? 11 : 6}
      xl={active ? 11 : 6}
    >
      <Accordion>
        <Card className={"card-orden-" + orden.status}>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Card.Body style={{ flex: 2 }}>
              <Card.Title className="card-title">
                <Row>
                  <Col xs={2}>
                    <h2
                      className={
                        "text-center-nombre card-header-list " +
                        "color-" +
                        orden.status
                      }
                    >
                      {orden.number}
                    </h2>
                  </Col>
                  <Col style={{ textAlign: "left" }} xs={6}>
                    {orden.table ? <h4>{"Mesa " + orden.table}</h4> : ""}
                    {mixto ? (
                      <h4 id={orden.status} className={"color-" + orden.status}>
                        {orden.status}
                      </h4>
                    ) : (
                      ""
                    )}
                    <h4 style={{ fontWeight: "700" }}>{orden.user_name}</h4>
                    <h6>
                      {fecha} {hora}
                    </h6>
                    <h6>{orden.ordenadoPor}</h6>
                    {orden.status !== "PENDIENTE" && (
                      <h6>
                        <span className="margin-title-card">Atendio:</span>{" "}
                        {usera && usera.fullName ? usera.fullName : ""}
                      </h6>
                    )}

                    {vencimiento && vencimientoR ? (
                      <h5>
                        Vence en{" "}
                        {vencimientoR > 1
                          ? parseInt(vencimientoR)
                          : parseInt(vencimientoR * 60)}
                        {vencimientoR > 1 ? " minutos" : " segundos"}
                      </h5>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col style={{ textAlign: "right" }} xs={4}>
                    {active ? (
                      <>
                        {userPoints.puntos ? (
                          <>
                            <h6 style={{ fontWeight: "bold" }}>
                              Usuario con puntos{" "}
                              <FontAwesomeIcon
                                icon={faStar}
                                size="lg"
                                color="#F3B122"
                              />
                            </h6>
                            <h6>
                              Puntos disponibles:
                              <Badge
                                bg="none"
                                className="px-3 py-2 fs-6"
                                style={{
                                  color: "brown",
                                  backgroundColor: "#FFE8C1",
                                }}
                              >
                                {userPoints.puntos ? userPoints.puntos : 0}
                              </Badge>
                            </h6>
                          </>
                        ) : (
                          <>
                            <h6 style={{ fontWeight: "bold" }}>
                              Usuario sin puntos{" "}
                            </h6>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <h6>Total</h6>
                        <h4
                          style={{ fontWeight: "700" }}
                          className={"color-" + orden.status}
                        >
                          ${parseFloat(orden.total).toFixed(2)}
                        </h4>
                      </>
                    )}
                  </Col>
                </Row>
              </Card.Title>
              <Card.Text className="card-text ">
                <Row>
                  <Col md={9}>
                    <h6>{orden.detalle?.length} productos:</h6>
                    {orden.detalle?.map((item) => (
                      <h6
                        style={{
                          listStyle: "disc",
                          display: "list-item",
                          marginLeft: "2rem",
                          fontWeight: "bold",
                        }}
                      >
                        {item.name + "(" + item.cantidad + ")"}
                      </h6>
                    ))}
                  </Col>
                  <Col md={3}>
                    <Button
                      className="newbutton-style nonfilledtext-color"
                      variant="ds"
                      onClick={() => openPedido(orden)}
                    >
                      Ver orden{" "}
                    </Button>
                  </Col>
                </Row>
              </Card.Text>
            </Card.Body>
            <Accordion.Collapse
              eventKey={orden.id}
              style={active ? { flex: 1 } : { width: "0px" }}
            >
              <Card.Body>
                <Card.Text className="card-text ">
                  <Row>
                    <Col md={7}>
                      <h6 style={{ fontSize: 17 }}>Subtotal del pedido:</h6>
                    </Col>
                    <Col md={5} style={{ textAlign: "right" }}>
                      <h6 style={{ fontSize: 18 }}>
                        ${parseFloat(orden.total).toFixed(2)}
                      </h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={7}>
                      <h6 style={{ fontSize: 17 }}>Puntos usados:</h6>
                    </Col>
                    <Col md={5} style={{ textAlign: "right" }}>
                      <h6 style={{ fontSize: 18, color: "#08832c" }}>
                        - ${puntos.toFixed(2)}
                      </h6>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col md={7}>
                      <h6 style={{ fontSize: 18, fontWeight: "bold" }}>
                        Total a pagar:
                      </h6>
                    </Col>
                    <Col md={5} style={{ textAlign: "right" }}>
                      <h6
                        style={{
                          fontSize: 20,
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        ${(parseFloat(orden.total) - puntos).toFixed(2)}
                      </h6>
                    </Col>
                  </Row>
                </Card.Text>
              </Card.Body>
            </Accordion.Collapse>
          </div>
          <Card.Footer className="card-footer">
            <Row>
              {orden.status === "PENDIENTE" ? (
                <>
                  <Col md={4}>
                    <CustomToggle eventKey={orden.id} text={"Nota:"} />
                  </Col>
                  <Col md={4} s>
                    <Button
                      variant="ds"
                      className="newbutton-style filled fullspace"
                      id="ticket2"
                      onClick={(e) => setImprimir(!imprimir)}
                    >
                      <FontAwesomeIcon icon={faList} /> Ticket
                      <ReactSwitch
                        id="active"
                        onChange={(e) => setImprimir(!imprimir)}
                        checked={imprimir}
                      />
                    </Button>
                  </Col>
                </>
              ) : (
                <Col md={6}>
                  <Button
                    variant="ds"
                    className="newbutton-style filled fullspace"
                    id="ticket"
                    onClick={() => setTicket(true)}
                  >
                    <FontAwesomeIcon icon={faTicket} /> Imprimir ticket
                  </Button>
                </Col>
              )}
              <Col md={orden.status === "PENDIENTE" ? 4 : 6}>
                <Button
                  variant="ds"
                  className="newbutton-style filled fullspace"
                  id="llamar"
                  onClick={() => Llamada()}
                >
                  <FontAwesomeIcon icon={faBell} /> Llamar al cliente
                </Button>
              </Col>
            </Row>
          </Card.Footer>
        </Card>
        <Accordion.Collapse
          eventKey={orden.id}
          onEntering={() => {
            document.getElementById("efectivo" + orden.id).focus();
          }}
          onEntered={(e) => {
            if (active) {
              const targetElement = document.getElementById("Pago" + orden.id);
              targetElement.scrollIntoView({
                behavior: "smooth",
                block: "end",
              });
            }
          }}
        >
          <Card
            id={"Pago" + orden.id}
            className="shadow-sm payment-card"
            style={{ borderColor: "#00a651", borderWidth: "3px" }}
          >
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold text-success m-0">PAGO</h6>
              </div>

              {/* RESUMEN */}
              <Row className="g-3 border-bottom pb-3 mb-3">
                <Col md={2}>
                  <small className="text-muted d-block">
                    Subtotal del pedido:
                  </small>
                  <h4 className="fw-bold">
                    ${parseFloat(orden.total).toFixed(2)}
                  </h4>
                </Col>

                <Col
                  md={3}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <small className="text-muted d-block">
                    Puntos disponibles:
                  </small>

                  <Badge
                    bg="none"
                    className="px-3 py-2 fs-6"
                    style={{
                      color: "brown",
                      backgroundColor: "#FFE8C1",
                    }}
                  >
                    {userPoints.puntos ? userPoints.puntos : 0} pts
                  </Badge>
                  <br />
                  {userPoints?.puntos && (
                    <Button
                      variant="success"
                      onClick={() => {
                        if (userPoints.puntos > parseFloat(orden.total)) {
                          setPuntos(orden.total);
                        } else {
                          setPuntos(userPoints.puntos);
                        }
                      }}
                      style={{ margin: 5, paddingTop: 3, paddingBottom: 3 }}
                    >
                      Usar todos
                    </Button>
                  )}
                </Col>

                <Col md={2} style={{ textAlign: "center" }}>
                  <small className="text-muted d-block mb-2">Usar puntos</small>

                  <InputGroup
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      variant="success"
                      id="efectivo"
                      style={{ flex: 1 }}
                      onClick={() => {
                        if (puntos > 0) {
                          setPuntos(puntos - 1);
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>

                    <input
                      style={{ flex: 5 }}
                      value={puntos}
                      className="text-center"
                      readOnly
                    />

                    <Button
                      variant="success"
                      id="efectivo"
                      style={{ flex: 1 }}
                      onClick={() => {
                        if (
                          userPoints.puntos &&
                          puntos < parseFloat(userPoints.puntos) &&
                          parseFloat(orden.total) - puntos > 0
                        ) {
                          setPuntos(puntos + 1);
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </InputGroup>
                  <Row style={{ textAlign: "center", marginTop: 8 }}>
                    <small className="text-success fw-bold">
                      Valor a descontar: -${puntos.toFixed(2)}
                    </small>
                  </Row>
                </Col>

                <Col md={3} style={{ textAlign: "center" }}>
                  <small className="text-muted d-block">
                    Total después de puntos:
                  </small>

                  <h3 className="text-success fw-bold">
                    ${(parseFloat(orden.total) - puntos).toFixed(2)}
                  </h3>
                </Col>

                <Col md={2} style={{ textAlign: "center" }}>
                  <small className="text-muted d-block">Total a pagar:</small>

                  <h3 className="text-danger fw-bold">
                    ${(parseFloat(orden.total) - puntos).toFixed(2)}
                  </h3>
                </Col>
              </Row>

              {/* MÉTODOS DE PAGO */}
              <Row className="g-3">
                <Col md={8}>
                  <Row>
                    <Col md={3}>
                      <label className="form-label fw-semibold">
                        💵 Efectivo
                      </label>

                      <Form.Control
                        name="efectivo"
                        id={"efectivo" + orden.id}
                        value={parseFloat(metodosPago.efectivo).toFixed(2)}
                        onKeyDown={changePago}
                      />
                    </Col>

                    <Col md={3}>
                      <label className="form-label fw-semibold">
                        💳 Tarjeta
                      </label>

                      <Form.Control
                        name="tarjeta"
                        id={"tarjeta" + orden.id}
                        value={parseFloat(metodosPago.tarjeta).toFixed(2)}
                        onKeyDown={changePago}
                      />
                    </Col>

                    <Col md={3}>
                      <label className="form-label fw-semibold">
                        🎟 Vale / Cupón
                      </label>

                      <Form.Control
                        name="vale"
                        id={"vale" + orden.id}
                        value={parseFloat(metodosPago.vale).toFixed(2)}
                        onKeyDown={changePago}
                      />
                    </Col>

                    <Col md={3}>
                      <label className="form-label fw-semibold">
                        🏦 Transferencia
                      </label>

                      <Form.Control
                        name="transferencia"
                        id={"transferencia" + orden.id}
                        value={parseFloat(metodosPago.transferencia).toFixed(2)}
                        onKeyDown={changePago}
                      />
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <h6>Atajos de efectivo:</h6>
                    {quickAmounts.map((item) => (
                      <Button
                        variant="ds"
                        className="newbutton-style filled"
                        id="atajo"
                        onClick={(e) => {
                          setMetodosPago({
                            ...metodosPago,
                            efectivo: "" + item,
                          });
                          document.getElementById("tarjeta" + orden.id).focus();
                        }}
                      >
                        ${item}
                      </Button>
                    ))}
                  </Row>
                </Col>

                <Col md={4}>
                  <div className="payment-summary h-100">
                    <div className="d-flex justify-content-between">
                      <span>Total capturado:</span>

                      <span className="text-success fw-bold">
                        ${totmp.toFixed(2)}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between mt-2">
                      <span>Restante por cubrir:</span>

                      <span className="text-success fw-bold">
                        ${(tot > 0 ? tot : 0).toFixed(2)}
                      </span>
                    </div>
                    {tot < 0 ? (
                      <div className="d-flex justify-content-between mt-2">
                        <span>Cambio</span>

                        <span className="text-success fw-bold">
                          ${Math.abs(tot).toFixed(2)}
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}

                    <div className="mt-3">
                      <Button
                        variant="success"
                        id="efectivo"
                        size="lg"
                        className="w-100"
                        onClick={confirmCobro}
                      >
                        {/* <BsCheckCircleFill className="me-2" /> */}
                        <FontAwesomeIcon icon={faCheck} />
                        Confirmar cobro
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* FOOTER */}
              <Row className="mt-4 align-items-center footer-points">
                <Col md={1}>
                  <FontAwesomeIcon icon={faInfoCircle} size="xl" color="blue" />
                </Col>

                <Col md={2}>
                  <small>Puntos usados:</small>
                  <div className="fw-bold text-success">{puntos} pts</div>
                </Col>

                <Col md={2}>
                  <small>Puntos restantes:</small>
                  <div className="fw-bold">
                    {userPoints.puntos ? userPoints.puntos - puntos : 0} pts
                  </div>
                </Col>

                <Col md={3}>
                  <small>Puntos que ganará esta compra:</small>
                  <div className="fw-bold text-danger">
                    {parseFloat(orden.puntosgenerados)} pts
                  </div>
                </Col>

                <Col md={4}>
                  <Button variant="outline-primary" className="w-100">
                    Ver detalle de puntos
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Accordion.Collapse>
      </Accordion>
      <Ticket
        orden={orden}
        registro={register}
        handleClose={handleClose}
        show={ticket}
      />
    </Col>
  );
};
export default OrdenLista;
